import React, { useState } from 'react';

import { Button } from 'reactstrap';

import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteManualVoucherPayment } from '../../../../actions/corporate/ManualVoucherPayment';

const ManualVoucherPaymentDeleteButton = ({
  manualVoucherPaymentId,
  dispatchDeleteManualVoucherPayment,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => {
    dispatchDeleteManualVoucherPayment({
      manualVoucherPaymentId,
    });
  };

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <Button color="danger" onClick={openModal}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>

      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
    </>
  );
};

ManualVoucherPaymentDeleteButton.propTypes = {
  manualVoucherPaymentId: PropTypes.number.isRequired,
  dispatchDeleteManualVoucherPayment: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteManualVoucherPayment: deleteManualVoucherPayment,
};

export default connect(
  null,
  mapDispatchToProps,
)(ManualVoucherPaymentDeleteButton);
